import { FC } from 'react';
import {Typography, Box} from "@mui/material";
import { useLangContext } from 'shared/features/Language';
import { CustomButton } from '../../../shared/components/Buttons/CustomButton';

export const HomeSection02:FC = () => {
  const {textData} = useLangContext();

  return (
    <Box sx={{textAlign: {lg: 'left', xs: 'center'}}}>
      <Typography
        variant='body2'
        sx={{
          marginBottom: {lg: '5px', xs: '5px'},
        }}
      >{textData.homeMotivationBuy}</Typography>
      <CustomButton width={{lg:'480px', xs:'240px'}}  onClick={() => { window.open('https://mixbricks.store', '_blank'); }}>{textData.buttonCaptionBuy}</CustomButton>
    </Box>
  );
}
